import React from 'react';
import { SomaParagraph, SomaSpinner } from '@soma/react';

import { Content } from './styles';

const LoaderFull = ({ message }) => (
  <Content data-testid="loading">
    <SomaSpinner size="xl" aria-label="Carregando..." />

    {message && <SomaParagraph>{message}</SomaParagraph>}
  </Content>
);

export default LoaderFull;
